/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  margin-top: 30px;
  h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
  }
  .MuiDivider-root {
    background-color: #e6e6e6;
    margin-top: 10px;
  }
  .style-list {
    height: 65px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 0px 20px;
    .form-column-field {
      width: 70%;
      .field {
        span {
          text-transform: none;
        }
        &.disabled {
          pointer-events: none;
          color: #aeaeae;

          .field {
            border: 0.5px solid #aeaeae;            
          }

          span {
            &.filled {
              color: #aeaeae;
            }
          }
        }
      }
    }
  }
`;
